import React from 'react';
import $ from 'jquery';
import { findIndex } from 'lodash';
// import Tooltip from '../../../commonComponents/Tooltip';
import PagerUd from '../../../commonComponents/PagerUd';
// import DeleteBtnWithConfirm from '../../../commonComponents/DeleteBtnWithConfirm';
import { FileDropAreaCt } from '../../../commonComponents/FileDropAreaCt';
import { onFileDrop, onFileDelete } from '../../../commonComponents/onFileModify';
import { DataListWrapper } from '../../../commonComponents/DataTable/DataTablePs';
import DropDownMenu, { optsBoolean } from '../../../commonComponents/DropDownMenu';
import { HrInWell } from '../../../commonComponents/Dividers';
import RequiredMark from '../../../commonComponents/RequiredMark';
import custJqAjax from '../../../commonJS/custJqAjax';
// import autoFill from '../../../commonJS/autoFill';
import parentStateHandler from '../../../commonJS/parentStateHandler';
import { textInputOnChange, dropDownOnChange } from '../../../commonJS/onFormChanges';
import inputValidation from '../../../commonJS/inputValidation';
import { formAppendMultiple } from '../../../helpers';
import { fetchWrapper } from '../../../commonJS/fetchWrapper';
import { typeChecker } from '../../../commonJS/typeChecker';

import {
	Modal,
	Button,
	FormControl,
	FormGroup,
	ControlLabel,
	Col,
	Row,
	Well
} from 'react-bootstrap';


export default class UserAccountModalCt extends React.Component {
	constructor(props) {
		super(props);
		this.handlers = {
			onMailFocus: e => {
				const htmlObj = e.currentTarget;
				if (htmlObj.value === '') {
					if (htmlObj.id === 'userAccount') {
						if (this.state.email !== '') {
							this.setState(
								{ userAccount: this.state.email },
								() => { htmlObj.select(); }
							);
						}
					} else if (htmlObj.id === 'email') {
						if (this.state.userAccount !== '') {
							this.setState(
								{ email: this.state.userAccount },
								() => { htmlObj.select(); }
							);
						}
					}
				}
			},
			textInputOnChange: e => {
				textInputOnChange(e, this);
			},
			deviceListOnChange: (keyName, ind, byCase) => {
				const
					// 用新陣列和新物件
					deviceList = this.state.deviceList.slice(),
					tarObj = { ...deviceList[ind] };

				let newValue;

				switch (keyName) {
					case 'device_status':
						let
							deviceList = this.state.deviceList,
							deviceCount = 0,
							limitDevice = this.props.propsPackageFromSkyFamily.systemEnvironment
								? this.props.propsPackageFromSkyFamily.systemEnvironment.Device_Code_Amount_Limit * 1
								: 0;

						if (limitDevice > 0) {
							// 如果限制為0，就不限制裝置數量
							for (let idxDList = 0; idxDList < deviceList.length; idxDList++) {
								if (deviceList[idxDList].device_status === '1')
									deviceCount++;
							}
							if (byCase.value === '1') {
								if ((deviceCount + 1) > limitDevice) {
									$('#modal-product').focus();
									alert('使用者裝置超過限制數');
									return;
								}
							}
						}

						newValue = byCase.value;
						break;
					case 'remark':
						newValue = byCase.currentTarget.value;
						break;
					default:

				}

				tarObj[keyName] = newValue;
				// 以新物件替換舊物件
				deviceList[ind] = tarObj;

				this.setState({ deviceList });

			},
			dropDownOnChange: (selection, stateName) => {
				const obj = dropDownOnChange(selection, stateName);

				this.setState(obj);
			},
			// onInputFocus: e => {
			//   autoFill(e, this);
			// },
			saveItem: isUpdate => {
				const state = this.state,
					props = this.props;
				// id = isUpdate ? (props.selectedItemId || props.params.itemId) : '';
				// ja_data_list = `${state.price_jp}|${state.delivery_jp}|${state.characteristics_jp}|${state.appliance_jp}`; 

				let formData = new FormData();

				formData.append('user_account', state.userAccount);
				formData.append('user_name', state.userName);
				formData.append('group_id', state.groupId);
				formData.append('role_id', state.roleId);
				formData.append('role_list', '0');
				formData.append('emp_id', state.empId);
				formData.append('email', state.email);
				formData.append('job_title', state.jobTitle);
				formData.append('mobile_phone', state.mobilePhone1);
				formData.append('mobile_phone2', state.mobilePhone2);
				formData.append('tel', state.tel);
				formData.append('ext', state.ext);
				formData.append('fax', state.fax);
				formData.append('is_admin', state.isAdmin);
				formData.append('agent_id', state.agentId);
				formData.append('is_display', state.isDisplay);
				formData.append('is_fix_user', state.isFixUser);
				formData.append('enabled', state.enabled);
				formData.append('device_code_check', state.deviceCodeCheck);


				// update時密碼非必填
				if (isUpdate) {
					if (state.userPwd) {
						formData.append('user_passwd', state.userPwd);
						formData.append('check_passwd', state.checkPwd);
					}
				} else {
					formData.append('user_passwd', state.userPwd);
					formData.append('check_passwd', state.checkPwd);
				}

				// 特別處理 for api 用delete api做修改啟用不啟用的變更…
				custJqAjax({
					type: 'POST',
					url: `/api/W_ManageAccount_${isUpdate ? 'Update' : 'Post'}.php`,
					data: formData,
					processData: false,
					contentType: false,
					success: res => {
						const data = res.result[0],
							resId = data.user_account;

						// local 端預更新 enabled 值
						data.enabled = state.enabled;

						// server 端更新 enabled 值
						if (
							this.variables.enableDefaultState !== state.enabled &&
							state.enabled === '0'
						) {
							this.handlers.deleteItem(resId);
						}

						this.handlers.onItemModified(data, isUpdate ? 'update' : 'create');

						// 指定的是item id 而非file name, 有上傳時不需做刪除特定檔的動作
						if (!this.uploadedFiles[0]) {
							// 處理update的檔案刪除動作

							if (isUpdate) this.fileWorker(undefined, resId);
						}

						// 處理設備設定更新
						if (state.deviceList.length) {
							for (const obj of state.deviceList) {
								const formData = formAppendMultiple({
									id: obj.id,
									user_id: obj.user_id,
									device_status: obj.device_status,
									remark: obj.remark
								});

								custJqAjax({
									type: 'POST',
									url: '/api/W_ManageAccount_Device_Code_Update.php',
									data: formData,
									processData: false,
									contentType: false,
									success: res => { }
								})
							}
						}

						// 處理上傳檔案
						this.fileWorker(true, resId);

						// 如果完全沒有執行檔案相關作業，會需要從這裡關閉
						if (this.filesWip < 1) {
							props.closeModal();
						}

						// 新增的情況下，連接到權限管理介面
						let extraStates = [], extraValues = [];
						new Promise((resolve, reject) => {
							if (!isUpdate) {
								extraStates.push('showPermissionModal', 'selectedRowIndex', 'selectedItemId', 'selectedItemName');
								extraValues.push(true, 0, resId, data.user_name);

								// copy permissions on copy mode 
								if (this.state.onCopy) {
									// fetch permissions of source id
									fetchWrapper(`/api/W_SkyFamily_User_Front_Permission_Get.php?user_id=${this.state.userId}`)
										.then((json) => {
											if (typeChecker(json.result) !== 'Array') json.result = [];
											// post permissions
											let permissionListString = '';

											json.result.forEach((item) => {
												permissionListString += `${item.front_name},${item.permission}|`;
											});

											// 有值才post
											if (permissionListString) {
												const formData = formAppendMultiple({
													user_id: data.user_id,
													front_name_permission_list: permissionListString
												});

												fetchWrapper('/api/W_SkyFamily_User_Front_Permission_Update.php',
													{
														method: 'POST',
														body: formData
													})
													.then((json) => {
														resolve();
													});
											} else {
												resolve();
											}
										})
								} else {
									resolve();
								}
							} else {
								resolve();
							}
						}).then(() => {
							// 更新搜尋結果並開啟權限管理介面
							this.props.parentStateHandler({
								states: ['doSearchUpdate', ...extraStates],
								newValues: [1, ...extraValues]
							});
						});
					}
				});
			},
			deleteItem: (id) => {
				let formData = new FormData();

				formData.append('user_account', id);

				custJqAjax({
					type: 'POST',
					url: '/api/W_ManageAccount_Delete.php',
					data: formData,
					processData: false,
					contentType: false,
					success: data => { }
				});
			},
			onItemModified: (data, mode) => {
				// 更新sortedData
				const itemId = data.user_account;
				let sortedData = this.props.sortedData,
					newItem = {
						...data
					};

				if (this.uploadedFiles[0]) {
					newItem.img_path = this.uploadedFiles[0].preview;
				} else if (this.state.deletedDownloadedFiles[0]) {
					newItem.img_path = '';
				}

				if (mode === 'create') {
					const len = sortedData._data.length;

					sortedData._data.push(newItem);
					// 新增的資料預設排在最前面
					sortedData._indexMap.unshift(len);
				} else if (mode === 'update') {
					let updateInd = findIndex(sortedData._data, { user_account: itemId });
					sortedData._data[updateInd] = newItem;
				} else if (mode === 'delete') {
					// let updateInd = findIndex(sortedData._data, {itemId: itemId});
					// 從indexMap中移除索引即可，不需從_data中移除資料
					// 確保為完整資料map而非搜尋篩選過的map
					// itemInd為刪除時會傳入的內容
					sortedData._data[data.itemInd].exception = true;
					const mapInd = sortedData._indexMap.indexOf(data.itemInd);
					sortedData._indexMap.splice(mapInd, 1);

				}

				// 雖然是相同的_data與_index資料，但owner 物件為新的，符合pure component需求
				sortedData = new DataListWrapper(sortedData._indexMap, sortedData._data);
				this.props.stateHandler({ states: 'userAccountSortedData', newValues: sortedData });

			},
			onEditClick: () => { this.setState({ onEdit: true, onCopy: false, editMode: 'Edit' }) },
			onCopyClick: () => {
				// 重置
				// this.fileSorts = {
				//   img: [],
				//   pdf: [],
				//   video: []
				// };

				// 複製情況下復原初始值
				this.variables.enableDefaultState = '1';

				this.setState({
					// set mode
					onCopy: true, onEdit: false, editMode: 'Copy',
					onPwdEdit: true,
					// clear itemId
					// itemId: '',
					// clear files
					downloadedFiles: [],
					downloadedImgs: [],
					downloadedPDFs: [],
					downloadedVideos: [],
					previewsImg: [],
					previewsPDF: [],
					previewsVideo: []
				}, () => {
					document.getElementById('userAccount').focus();
				});

			},
			loadItemData: () => {
				const id = this.props.params.itemId;

				custJqAjax({
					type: 'GET',
					ajaxsWip: this.ajaxsWip,
					custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
					url: `/api/W_ManageAccount_Get.php?user_account=${id}`,
					processData: false,
					contentType: false,
					success: res => {
						if (!res.result[0].user_id) return;
						const data = res.result[0],
							filePath = `${data.img_path}?v=${new Date().getTime()}`,
							orinFiles = [{ file_name: filePath, thumbnail: filePath }];

						const downloadedFiles = this.fileFilter(orinFiles);

						// 特別處理 for api
						this.variables.enableDefaultState = data.enabled;

						this.setState({
							userAccount: data.user_account,
							userName: data.user_name,
							userId: data.user_id,
							groupId: data.user_group,
							roleId: data.role_id,
							empId: data.emp_id,
							email: data.email,
							jobTitle: data.job_title,
							mobilePhone1: data.mobile_phone,
							mobilePhone2: data.mobile_phone2,
							tel: data.tel,
							ext: data.ext,
							fax: data.fax,
							isAdmin: data.is_admin,
							agentId: data.agent_id,
							isDisplay: data.is_display,
							isFixUser: data.is_fix_user,
							enabled: data.enabled,
							onPwdEdit: false,
							deviceCodeCheck: data.device_code_check,
						});

						// for downloaded files that uploaded before
						this.onFileDrop(downloadedFiles);

						custJqAjax({
							type: 'GET',
							ajaxsWip: this.ajaxsWip,
							custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
							url: `/api/W_ManageAccount_Device_Code_Get.php?user_id=${data.user_id}`,
							processData: false,
							contentType: false,
							success: res => {
								this.setState({ deviceList: res.result });
							}
						});
					}
				});

			},
			rowIndexCheck: passUpdate => {
				// 預防使用者在modal重新整理，導致無selectedRowIndex，造成上一筆下一筆功能異常
				if (this.props.params &&
					this.props.params.itemId &&
					!this.props.selectedRowIndex &&
					this.props.selectedRowIndex !== 0) {

					// 初始狀態的ind和indexMap是一樣的
					let itemId = this.props.params.itemId,
						ind = findIndex(this.props.filteredSortedData._data, { user_account: itemId });

					if (!passUpdate) {
						this.props.parentStateHandler({
							states: ['selectedItemId', 'selectedRowIndex'],
							newValues: [itemId, ind]
						});
					}

					return ind;
				}
				return this.props.selectedRowIndex;
			},
			changeItem: () => {
				this.handlers.loadItemData();
			},
			onPreviousClick: () => {
				let selectedRowIndex = this.handlers.rowIndexCheck(),
					r = (selectedRowIndex - 1),
					rowIndex = r >= 0 ? r : 0;
				if (rowIndex !== selectedRowIndex) {
					// let id = this.props.productSortedData.getObjectAt(rowIndex).id;
					this.props.onRowClick('e', rowIndex, this.props.filteredSortedData, '', 1);
					// this.handlers.loadItemData(id);

					// load new Product
					this.funcs.resetState(this.handlers.changeItem);
				}
			},
			onNextClick: () => {
				let selectedRowIndex = this.handlers.rowIndexCheck(),
					r = (selectedRowIndex + 1),
					filteredSortedData = this.props.filteredSortedData,
					max = filteredSortedData.getSize(),
					rowIndex = r < max ? r : (max - 1);
				if (rowIndex !== selectedRowIndex) {
					// let id = productSortedData.getObjectAt(rowIndex).id;
					this.props.onRowClick('e', rowIndex, filteredSortedData, '', 1);
					// this.handlers.loadItemData(id);

					// load new Product
					this.funcs.resetState(this.handlers.changeItem);
				}
			}
		};

		this.variables = {
			enableDefaultState: '1'
		};

		this.funcs = {
			resetState: cb => {

				this.uploadedFiles = [];

				this.setState({
					// item ===
					userAccount: '',
					userPwd: '',
					checkPwd: '',
					userName: '',
					groupId: '',
					roleId: '',
					empId: '',
					email: '',
					jobTitle: '',
					mobilePhone1: '',
					mobilePhone2: '',
					tel: '',
					ext: '',
					fax: '',
					// 0 or 1
					isAdmin: '0',
					agentId: '0',
					isDisplay: '1',
					isFixUser: '0',
					enabled: '1',
					deviceList: [],
					deviceCodeCheck: '0',
					// ===

					// by case ====
					onPwdEdit: true,
					// ===

					// file crud 相關 ====================
					downloadedFiles: [],
					downloadedImgs: [],
					downloadedPDFs: [],
					downloadedVideos: [],
					previewsImg: [],
					previewsPDF: [],
					previewsVideo: [],
					deletedDownloadedFiles: [],
					fileWorkInProgress: false, // 控制檔案上傳進度用
					forceUpdate: true,
					// ====================
					// common
					btnSaveDisable: true,
					btnDeleteDisable: true,
					onEdit: false,
					onCopy: false,
					editMode: 'View'
				}, cb ? cb : '');
			}
		};

		this.parentStateHandler = ({ states, newValues }) => {
			parentStateHandler({ states, newValues, parentThis: this });
		};

		this.ajaxsWip = [];

		// file crud相關 ===========
		// for file upload，不需渲染的資料不使用state，避免多餘的render check
		this.uploadedFiles = [];
		// this.fileSorts = {
		//   img: [],
		//   pdf: [],
		//   video: []
		// };

		// this.updateFilesSort = (objSortedNameURL, productId) => {
		//   // 更新檔案排序
		//   let postData = new FormData();
		//   postData.append('id', productId);
		//   postData.append('type', 'Product');
		//   postData.append('file_id_list', getFileIdList(objSortedNameURL).join());

		//   custJqAjax({
		//     type: 'POST',
		//     url: '/api/W_SkyFamily_System_Extra_Files_Sort_Update.php',
		//     data: postData,
		//     processData: false,
		//     contentType: false,
		//     complete: () => {}
		//   });
		// };

		// for downloaded files that uploaded before
		this.onFileDrop = downloadedFiles => {
			onFileDrop(downloadedFiles, '', this, true, false, false, this.fileSorts, this.parentStateHandler);
		};

		this.onFileDelete = (type, fileName) => {
			// onFileDelete是在onFileDrop裡面會被使用，
			// type, fileName在裡面預設會傳入

			// 編輯模式下remove icon才有效
			let itemId = '';
			if (this.props.params) itemId = this.props.params.itemId;

			if (this.state.editMode !== 'View' || !itemId) {
				onFileDelete(type, fileName, this, true);
			} else {
				return;
			}

		};

		// 配合api
		this.fileFilter = orinFiles => {
			// 檔案預處理
			let name = '', dotInd = '', type = '', questionInd = '';

			const downloadedFiles = orinFiles.map((item, ind) => {
				name = item.file_name;
				dotInd = name.lastIndexOf('.');
				questionInd = name.lastIndexOf('?');
				type = name.slice(dotInd + 1, questionInd);

				switch (type) {
					case 'jpg':
						item.type = 'image/jpeg';
						break;
					case 'png':
						item.type = 'image/png';
						break;
					case 'svg':
						item.type = 'image/svg+xml';
						break;
					case 'pdf':
						item.type = 'application/pdf';
						break;
					case 'mp4':
						item.type = 'video/mp4';
						break;
					default:
				}

				return item;

			});

			return downloadedFiles;
		};

		this.fileWorker = (isUpload, fileId) => {
			let fileData = new FormData(),
				requreField = 'user_account',
				apiType = 'W',
				apiKeyWord = 'Upload_Delete',
				len = this.state.deletedDownloadedFiles.length;

			if (isUpload) {
				requreField = '$_FILES';
				apiType = 'W';
				apiKeyWord = 'Upload_Post';
				len = this.uploadedFiles.length;
				fileData.append('user_account', fileId);
			}

			// api只支援一次傳一個檔，要用迴圈處理
			if (len > 0) {
				this.filesWip += len;
				if (!this.state.fileWorkInProgress) this.setState({ fileWorkInProgress: true });

				fileData.append('type', 'UserProfile');

				// do not make functions in a loop;
				let printRes = (res, uploadedFileName, uploadedFileType) => {
					this.filesWip -= 1;
					if (this.filesWip < 1) {
						this.setState({ fileWorkInProgress: false });
						// 更新file sort
						this.props.closeModal();
					}
				};

				for (let i = 0; i < len; i++) {
					let value = '', uploadedFileName, uploadedFileType;
					if (isUpload) {
						value = this.uploadedFiles[i];
						uploadedFileName = value.name;
						uploadedFileType = value.type;
					} else {
						// let fileName = this.state.deletedDownloadedFiles[i].file_name,
						//     backslashInd = fileName.lastIndexOf('/'),
						//     dotInd = fileName.lastIndexOf('.'),
						//     fileId = fileName.slice(backslashInd + 1, dotInd);

						value = fileId;
					}

					fileData.append(requreField, value);
					custJqAjax({
						type: 'POST',
						url: `/api/${apiType}_SaleSky_File${apiKeyWord}.php`,
						data: fileData,
						processData: false,
						contentType: false,
						complete: res => { printRes(res, uploadedFileName, uploadedFileType); }
					});
				}
			}
		};

		// 控制檔案上傳進度用
		this.filesWip = 0;

		// ======================

		// setTimeout Id
		this.timer = '';

		this.state = {
			// item ===
			optsDeviceStatus: [],
			deviceList: [],
			deviceCodeCheck: '0',
			userAccount: '',
			userPwd: '',
			checkPwd: '',
			userId: '',
			userName: '',
			groupId: '',
			roleId: '',
			empId: '',
			email: '',
			jobTitle: '',
			mobilePhone1: '',
			mobilePhone2: '',
			tel: '',
			ext: '',
			fax: '',
			// 0 or 1
			isAdmin: '0',
			agentId: '0',
			isDisplay: '1',
			isFixUser: '0',
			enabled: '1',
			// ===

			// by case ====
			onPwdEdit: true,
			// ===

			// file crud 相關 ====================
			downloadedFiles: [],
			downloadedImgs: [],
			downloadedPDFs: [],
			downloadedVideos: [],
			previewsImg: [],
			previewsPDF: [],
			previewsVideo: [],
			deletedDownloadedFiles: [],
			fileWorkInProgress: false, // 控制檔案上傳進度用
			forceUpdate: true,
			// ====================
			// common
			btnSaveDisable: true,
			btnDeleteDisable: true,
			onEdit: false,
			onCopy: false,
			editMode: 'View'
		};
	}


	componentDidMount() {
		if (this.props.params && this.props.params.itemId) {
			this.handlers.loadItemData();

			const data = [
				{ value: '0', label: '申請中' },
				{ value: '1', label: '核准' },
				{ value: '2', label: '不核准' },
				{ value: '3', label: '作廢' }
			];

			this.setState({ optsDeviceStatus: data });
		} else {
			document.getElementById('userAccount').focus();
		}
	}

	componentDidUpdate(prevProps, prevState) {
		// 資料驗證ok才可送出
		if (
			!this.state.userName ||
			!this.state.groupId ||
			!this.state.roleId ||
			!inputValidation(this.state.userAccount, { emailTest: true }).emailTest ||
			!inputValidation(this.state.email, { emailTest: true }).emailTest ||
			(
				(
					!inputValidation(this.state.userPwd, { lengthTest: 6 }).lengthTest ||
					!inputValidation(this.state.checkPwd, { equalTest: this.state.userPwd }).equalTest
				) && this.state.onPwdEdit
			)
		) {

			if (!this.state.btnSaveDisable) this.setState({ btnSaveDisable: true });

		} else if (this.state.btnSaveDisable) {
			this.setState({ btnSaveDisable: false });
		}
	}

	componentWillUnmount() {
		this.props.propsPackageFromSkyFamily.ajaxAborter(this.ajaxsWip);
		clearTimeout(this.timer);
	}

	render() {
		const props = this.props,
			state = this.state,
			handlers = this.handlers;

		let saveBtn = '',
			deleteBtn = '',
			editable = 0,
			modeBtns = '',
			itemId = '',
			pagerUd = '',
			saveBtnText = state.fileWorkInProgress ? '檔案上傳中...' : '儲存';

		if (props.params) itemId = props.params.itemId;
		// else  itemId = props.itemId;

		if (state.editMode !== 'View' || !itemId) {
			saveBtn = (
				<Button disabled={state.btnSaveDisable}
					onClick={() => { handlers.saveItem(state.onEdit ? 1 : 0) }}
					style={{ float: 'right', marginLeft: 5, position: 'relative', zIndex: '3' }}>
					{saveBtnText}
				</Button>
			);
			editable = 1;
		} else {
			// let tipText = '';
			modeBtns = (
				<span>
					<Button
						onClick={handlers.onCopyClick}
						style={{ float: 'right', marginLeft: 5, position: 'relative', zIndex: '3' }}>
						複製
					</Button>
					<Button
						onClick={handlers.onEditClick}
						style={{ float: 'right', marginLeft: 5, position: 'relative', zIndex: '3' }}>
						編輯
					</Button>
				</span>
			);

			let disablePreviousBtn = false,
				disableNextBtn = false;

			if (props.filteredSortedData.getSize) {
				const selectedRowIndex = handlers.rowIndexCheck(true),
					max = props.filteredSortedData.getSize();

				disablePreviousBtn = (selectedRowIndex === 0);
				disableNextBtn = (selectedRowIndex === (max - 1));
			}

			pagerUd = <PagerUd style={{ position: 'absolute', width: '100%', marginTop: 0, marginBottom: 0, marginLeft: -15, fontSize: 14, padding: '1px 0' }}
				onPreviousClick={handlers.onPreviousClick}
				onNextClick={handlers.onNextClick}
				disablePreviousBtn={disablePreviousBtn}
				disableNextBtn={disableNextBtn} />;
		}

		// 不做刪除功能
		// deleteBtn = state.onEdit ? 
		//               <DeleteBtnWithConfirm
		//                 style={{float: 'right', marginLeft: 5, position: 'relative', zIndex: '3'}}
		//                 onClick={handlers.deleteItem}
		//                 title='Are you sure?' />
		//             : '';

		const { previewsImg, previewsPDF, previewsVideo } = state,
			downloadedFilesPreview = { previewsImg, previewsPDF, previewsVideo };


		const showEditPwdBtn = (
			(state.editMode === 'Edit' ||
				state.editMode === 'View'
			) && state.editMode !== 'Copy'
			&& props.params
			&& props.params.itemId
		);

		return (
			<Modal id='modal-product' keyboard={false} backdrop='static' show={true} onHide={props.closeModal} bsSize='large'>
				<Modal.Header>
					<Modal.Title>
						<span style={{ padding: '6px 0px', height: 34, lineHeight: '34px' }}>
							{
								itemId ?
									<span style={{ float: 'left' }}>
										<span style={{ color: 'rgba(0, 0, 200, .7' }}>{state.editMode}</span> Mode
									</span>
									:
									<span>New Account</span>
							}
						</span>
						<Button onClick={props.closeModal} style={{ float: 'right', marginLeft: 5, position: 'relative', zIndex: '3' }}>取消</Button>
						{saveBtn}
						{modeBtns}
						{deleteBtn}
						{pagerUd}
					</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<Well style={{ marginBottom: 15 }}>
						<Row>
							<Col sm={6}>
								<FormGroup controlId='userAccount'
									validationState={inputValidation(state.userAccount, { emailTest: true }).emailTest ? null : 'error'}>
									<ControlLabel style={{ fontWeight: 'bold' }}><RequiredMark />使用者帳號 (必須為電子郵件格式)</ControlLabel>
									<FormControl
										disabled={state.onCopy ? false : itemId}
										type='text'
										onFocus={this.handlers.onMailFocus}
										onChange={handlers.textInputOnChange}
										value={state.userAccount}
										style={{ height: 36 }} />
								</FormGroup>

								<FormGroup controlId='userName'
									validationState={state.userName ? null : 'error'}>
									<ControlLabel style={{ fontWeight: 'bold' }}><RequiredMark />使用者名稱</ControlLabel>
									<FormControl
										disabled={!editable}
										type='text'
										onChange={handlers.textInputOnChange}
										value={state.userName}
										style={{ height: 36 }} />
								</FormGroup>
								{
									showEditPwdBtn ?
										<Button
											disabled={!editable}
											style={{ height: 36, width: '100%', marginTop: 18 }}
											onClick={() => {
												this.setState({
													onPwdEdit: !this.state.onPwdEdit,
													userPwd: '',
													checkPwd: ''
												});
											}}
										>
											{this.state.onPwdEdit ? '取消密碼修改' : '開啟密碼編輯介面'}
										</Button>
										: ''
								}

							</Col>

							<Col sm={6}>
								<FileDropAreaCt
									placeholderStyle={showEditPwdBtn ? { height: 200.5, padding: 0, lineHeight: '200.5px' } : {}}
									accept='image/jpeg, image/png, image/svg+xml'
									singleFileLimit={true}
									parentStateHandler={this.parentStateHandler}
									disabled={!editable}
									uploadedFiles={this.uploadedFiles}
									defaultText='點擊上傳使用者圖片'
									downloadedFilesPreview={downloadedFilesPreview} />

							</Col>

							<Col sm={12}>
								<HrInWell />
							</Col>

							{
								this.state.onPwdEdit ?
									<div>
										<Col sm={6}>
											<FormGroup controlId='userPwd'
												validationState={inputValidation(state.userPwd, { lengthTest: 6 }).lengthTest ? null : 'error'}>
												<ControlLabel style={{ fontWeight: 'bold' }}><RequiredMark />密碼 (至少6個英數字)</ControlLabel>
												<FormControl
													disabled={!editable}
													type='password'
													onChange={handlers.textInputOnChange}
													value={state.userPwd}
													style={{ height: 36 }} />
											</FormGroup>


										</Col>
										<Col sm={6}>
											<FormGroup controlId='checkPwd'
												validationState={inputValidation(state.checkPwd, { equalTest: state.userPwd }).equalTest ? null : 'error'}>
												<ControlLabel style={{ fontWeight: 'bold' }}><RequiredMark />確認密碼</ControlLabel>
												<FormControl
													disabled={!editable}
													type='password'
													onChange={handlers.textInputOnChange}
													value={state.checkPwd}
													style={{ height: 36 }} />
											</FormGroup>
										</Col>
									</div>
									: ''
							}

							<DropDownMenu
								labelStyle={{ fontWeight: 'bold' }}
								sm={6}
								label='群組'
								required={true}
								validationState={state.groupId ? null : 'error'}
								options={props.optsUserGroup}
								disabled={!editable}
								onChange={handlers.dropDownOnChange}
								value={state.groupId}
								stateName='groupId' />

							<DropDownMenu
								labelStyle={{ fontWeight: 'bold' }}
								sm={6}
								label='角色'
								required={true}
								validationState={state.roleId ? null : 'error'}
								options={props.optsUserRole}
								disabled={!editable}
								onChange={handlers.dropDownOnChange}
								value={state.roleId}
								stateName='roleId' />

							<Col sm={12}>
								<FormGroup controlId='email'
									validationState={inputValidation(state.email, { emailTest: true }).emailTest ? null : 'error'}>
									<ControlLabel style={{ fontWeight: 'bold' }}><RequiredMark />電子郵件</ControlLabel>
									<FormControl
										disabled={!editable}
										type='text'
										onFocus={this.handlers.onMailFocus}
										onChange={handlers.textInputOnChange}
										value={state.email}
										style={{ height: 36 }} />
								</FormGroup>
							</Col>

						</Row>
					</Well>

					<Well>
						<Row>
							<Col sm={6}>
								<FormGroup controlId='empId'>
									<ControlLabel style={{ fontWeight: 'bold' }}>員工編號</ControlLabel>
									<FormControl
										disabled={!editable}
										type='text'
										onChange={handlers.textInputOnChange}
										value={state.empId}
										style={{ height: 36 }} />
								</FormGroup>
							</Col>

							<Col sm={6}>
								<FormGroup controlId='jobTitle'>
									<ControlLabel style={{ fontWeight: 'bold' }}>職稱</ControlLabel>
									<FormControl
										disabled={!editable}
										type='text'
										onChange={handlers.textInputOnChange}
										value={state.jobTitle}
										style={{ height: 36 }} />
								</FormGroup>
							</Col>

							<Col sm={6}>
								<FormGroup controlId='mobilePhone1'>
									<ControlLabel style={{ fontWeight: 'bold' }}>行動電話 1</ControlLabel>
									<FormControl
										disabled={!editable}
										type='text'
										onChange={handlers.textInputOnChange}
										value={state.mobilePhone1}
										style={{ height: 36 }} />
								</FormGroup>
							</Col>

							<Col sm={6}>
								<FormGroup controlId='mobilePhone2'>
									<ControlLabel style={{ fontWeight: 'bold' }}>行動電話 2</ControlLabel>
									<FormControl
										disabled={!editable}
										type='text'
										onChange={handlers.textInputOnChange}
										value={state.mobilePhone2}
										style={{ height: 36 }} />
								</FormGroup>
							</Col>

							<Col sm={4}>
								<FormGroup controlId='tel'>
									<ControlLabel style={{ fontWeight: 'bold' }}>室內電話</ControlLabel>
									<FormControl
										disabled={!editable}
										type='text'
										onChange={handlers.textInputOnChange}
										value={state.tel}
										style={{ height: 36 }} />
								</FormGroup>
							</Col>

							<Col sm={2}>
								<FormGroup controlId='ext'>
									<ControlLabel style={{ fontWeight: 'bold' }}>分機</ControlLabel>
									<FormControl
										disabled={!editable}
										type='text'
										onChange={handlers.textInputOnChange}
										value={state.ext}
										style={{ height: 36 }} />
								</FormGroup>
							</Col>

							<Col sm={6}>
								<FormGroup controlId='fax'>
									<ControlLabel style={{ fontWeight: 'bold' }}>傳真</ControlLabel>
									<FormControl
										disabled={!editable}
										type='text'
										onChange={handlers.textInputOnChange}
										value={state.fax}
										style={{ height: 36 }} />
								</FormGroup>
							</Col>
						</Row>
					</Well>

					<Well>
						<Row>
							<DropDownMenu
								labelStyle={{ fontWeight: 'bold' }}
								sm={6}
								label='系統管理員'
								options={optsBoolean}
								disabled={!editable}
								onChange={handlers.dropDownOnChange}
								value={state.isAdmin}
								stateName='isAdmin' />

							<DropDownMenu
								labelStyle={{ fontWeight: 'bold' }}
								sm={6}
								label='維修人員'
								options={optsBoolean}
								disabled={!editable}
								onChange={handlers.dropDownOnChange}
								value={state.isFixUser}
								stateName='isFixUser' />

							<DropDownMenu
								labelStyle={{ fontWeight: 'bold' }}
								sm={6}
								label='經銷商'
								options={optsBoolean}
								disabled={!editable}
								onChange={handlers.dropDownOnChange}
								value={state.agentId}
								stateName='agentId' />

							<DropDownMenu
								labelStyle={{ fontWeight: 'bold' }}
								sm={6}
								label='是否於下拉選項中顯示'
								options={optsBoolean}
								disabled={!editable}
								onChange={handlers.dropDownOnChange}
								value={state.isDisplay}
								stateName='isDisplay' />

							<DropDownMenu
								labelStyle={{ fontWeight: 'bold' }}
								sm={12}
								label='啟用帳號'
								options={optsBoolean}
								disabled={!editable}
								onChange={handlers.dropDownOnChange}
								value={state.enabled}
								stateName='enabled' />
						</Row>
					</Well>
					{/* 裝置檢查設定 */}
					<Well style={{ marginBottom: 0 }}>
						<Row>
							<DropDownMenu
								labelStyle={{ fontWeight: 'bold' }}
								sm={12}
								label='檢查裝置'
								options={optsBoolean}
								disabled={!editable}
								onChange={handlers.dropDownOnChange}
								value={state.deviceCodeCheck}
								stateName='deviceCodeCheck' />

							{
								state.deviceList.length !== 0 ?
									<Col sm={12}>
										<Row style={{ fontWeight: 'bold', marginBottom: 5 }}>
											<Col sm={2}>狀態</Col>
											<Col sm={3}>說明</Col>
											<Col sm={2}>裝置類型</Col>
											<Col sm={3}>申請日期時間</Col>
											<Col sm={2}>裝置碼</Col>
										</Row>
									</Col>
									: null
							}

							{
								state.deviceList.map((item, ind) => {
									return (
										<Col sm={12} key={ind}>
											<Row>
												<DropDownMenu
													labelStyle={{ display: 'none' }}
													sm={2}
													label={'device_status'}
													options={state.optsDeviceStatus}
													disabled={!editable}
													onChange={(selection, stateName) => { handlers.deviceListOnChange('device_status', ind, selection, stateName); }}
													value={state.deviceList[ind].device_status}
													stateName='deviceList' />

												<Col sm={3}>
													<FormGroup controlId='remark'>
														<FormControl
															disabled={!editable}
															type='text'
															onChange={(e) => { handlers.deviceListOnChange('remark', ind, e); }}
															value={state.deviceList[ind].remark} />
													</FormGroup>
												</Col>

												<Col sm={2}>
													<FormGroup controlId='device_type'>
														<FormControl
															type='text'
															disabled={true}
															value={state.deviceList[ind].device_type} />
													</FormGroup>
												</Col>

												<Col sm={3}>
													<FormGroup controlId='device_date'>
														<FormControl
															type='text'
															disabled={true}
															value={state.deviceList[ind].device_date} />
													</FormGroup>
												</Col>

												<Col sm={2}>
													<FormGroup controlId='device_code'>
														<FormControl
															type='text'
															disabled={true}
															value={state.deviceList[ind].device_code} />
													</FormGroup>
												</Col>
											</Row>
										</Col>
									);
								})
							}
						</Row>
					</Well>
				</Modal.Body>
				<Modal.Footer>
					{pagerUd}
					<Button onClick={props.closeModal} style={{ float: 'right', marginLeft: 5, position: 'relative', zIndex: '3' }}>取消</Button>
					{saveBtn}
					{deleteBtn}
				</Modal.Footer>
			</Modal >
		);
	}
}


// WEBPACK FOOTER //
// ./src/salesky/routes/newAdmin/UserAccountModalCt.jsx